export default __webpack_public_path__ + "static/media/icon-search.9f01af10.svg";